import { render, staticRenderFns } from "./Catalog.vue?vue&type=template&id=1fae4a29&scoped=true&"
import script from "./Catalog.vue?vue&type=script&lang=ts&"
export * from "./Catalog.vue?vue&type=script&lang=ts&"
import style0 from "./Catalog.vue?vue&type=style&index=0&id=1fae4a29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fae4a29",
  null
  
)

export default component.exports